import { httpInterceptor } from '../http-interceptor';

export class ProductionService {
  static ENDPOINTS = {
    GET_ALL: 'Production/searchproduction',
    GET_PRINTERS: 'Production/printers',
    QUARANTINE: 'production/quarantine',
    RELEASE: 'production/release',
    DELETE: 'shipment/delete',
    GET_BY_ID: 'production/getproductiondetails',
    IMPORT_SHIPMENT: 'shipment/uploadshipment',
    PRINT_LABEL: 'Production/printLabel',
    SCRAP_CATALOG: 'Production/scrapcatalog',
    PRINT_LABEL_NOT_IN_PRODUCTION: 'Production/printlabelfornotinproduction',
    SCAN_LABEL: 'Production/scanlabel',
    REPRINT_LABEL: 'Production/reprintlabel',
    LOST_LABEL_REPRINT: 'Production/lostlabelreprint',
    PRINT_CUSTOM_LABELS: 'Production/printcustomlabels',
    LABEL_QUANTITY_SPLITTER: 'Production/labelsplitter',
  };

  static async getAllProduction(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
  }

  static async printlabel(data) {
    return httpInterceptor.post(this.ENDPOINTS.PRINT_LABEL, data);
  }
  static async scrapcatalog(data) {
    return httpInterceptor.post(this.ENDPOINTS.SCRAP_CATALOG, data);
  }
  static async printlabelfornotinproduction(data) {
    return httpInterceptor.post(this.ENDPOINTS.PRINT_LABEL_NOT_IN_PRODUCTION, data);
  }
  static async scanlabel(data) {
    return httpInterceptor.post(this.ENDPOINTS.SCAN_LABEL, data);
  }
  static async reprintlabel(data) {
    return httpInterceptor.post(this.ENDPOINTS.REPRINT_LABEL, data);
  }
  static async lostlabelreprint(data) {
    return httpInterceptor.post(this.ENDPOINTS.LOST_LABEL_REPRINT, data);
  }
  static async printcustomlabels(data) {
    return httpInterceptor.post(this.ENDPOINTS.PRINT_CUSTOM_LABELS, data);
  }
  static async labelquantitysplitter(data) {
    return httpInterceptor.post(this.ENDPOINTS.LABEL_QUANTITY_SPLITTER, data);
  }

  static async getPrinters() {
    return httpInterceptor.get(this.ENDPOINTS.GET_PRINTERS);
  }
//
  static async getProductionById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  static async createShipment(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }
  static async Quarantine(data) {
    return httpInterceptor.post(this.ENDPOINTS.QUARANTINE, data);
  }
  static async Release(data) {
    return httpInterceptor.post(this.ENDPOINTS.RELEASE, data);
  }
  static async importShipment(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.IMPORT_SHIPMENT, data);
  }
  static async updateShipment(id, data) {
    return httpInterceptor.put(`${this.ENDPOINTS.UPDATE}/${id}`, data);
  }

  static async deleteShipment(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }
}
